<script setup lang="ts">
import { ChevronRightIcon } from 'Common/components/elements/icons/Icons'
import type { BreadCrumbItem } from 'Common/types/utils/breadCrumbItem'

interface PropTypes {
  items: Array<BreadCrumbItem>
  labelStyle?: string
}

const props = defineProps<PropTypes>()
</script>

<template>
  <el-breadcrumb :separator-icon="ChevronRightIcon">
    <template v-for="item in props.items" :key="`${item.route}-BreadCrumb`">
      <el-breadcrumb-item :to="item?.route && { name: item.route, params: item.params, query: { ...item.query } }">
        <span :class="props?.labelStyle">{{ item.label }}</span>
      </el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>
